import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "./ConfirmationWithReason.css";
import { TextField } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 616,
  bgcolor: "#FFFFFF",
  boxShadow: 24,
  p: 4,
};

function ConfirmationWithReason(props) {
  const {
    showReason,
    currentReason,
    open,
    handleClose,
    title,
    description,
    placeholder,
    onCancel,
    cancelButtonLabel,
    onConfirm,
    confirmButtonLabel,
  } = props;

  const [reason, setReason] = useState(currentReason || null);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="confirmation-with-reason"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" sx={{ mb: 2 }}>
          {title}
        </Typography>

        {description && (
          <Typography id="modal-modal-description" sx={{ mb: 2, mt: 2 }}>
            {description}
          </Typography>
        )}

        {showReason && (
          <div className="reason-div mt-2">
            <TextField
              multiline
              value={reason}
              className="reason-div-textfield"
              data-testid="reason_textbox"
              rows={8}
              onChange={(e) => {
                setReason(e.target.value);
              }}
              placeholder={placeholder || ""}
              style={{ width: "100%", padding: 1 }}
            />
          </div>
        )}

        <div className="action-btn-div mt-4 action-popup-share">
          <Button
            className="action-button"
            variant="outlined"
            onClick={(e) => {
              setReason("");
              onCancel(e);
            }}
            data-testid="cancel-action"
          >
            {cancelButtonLabel}
          </Button>
          <Button
            className="action-button ml-4"
            variant="contained"
            onClick={(e) => {
              /*istanbul ignore next */
              setReason("");
              onConfirm(e, reason);
            }}
            data-testid="confirm-action"
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

// ✅ Add PropTypes validation
ConfirmationWithReason.propTypes = {
  showReason: PropTypes.bool,
  currentReason: PropTypes.string,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  cancelButtonLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  confirmButtonLabel: PropTypes.string,
};

// ✅ Default props for optional values
ConfirmationWithReason.defaultProps = {
  showReason: false,
  currentReason: "",
  description: "",
  placeholder: "",
  cancelButtonLabel: "Cancel",
  confirmButtonLabel: "Confirm",
};

export default ConfirmationWithReason;
